jQuery(function ($) {
  $(".single-content a").each(function (i, val) {
    if ($(this).parents("#ez-toc-container").length === 0) {
      $(this).attr("target", "_blank");
    }
  });
});
